import React from "react";
import SellerList from "./SellerList";

const Seller = () => <SellerList />;

export default Seller;
